import * as React from "react";
import { Chip, type ChipProps } from "@mui/material";

interface HealthBadgeProps {
  status: string | null | undefined;
}

const COLOR_MAP: Record<string, ChipProps["color"]> = {
  ok: "success",
  healthy: "success",
  passed: "success",
  ready: "success",
  connected: "success",
  degraded: "warning",
  starting: "warning",
  not_connected: "warning",
  unhealthy: "error",
  failed: "error",
  errored: "error",
  disconnected: "error",
  unknown: "default",
};

/** Maps a backend-reported status string to a colored chip — displays the exact string, never a derived value. */
export function HealthBadge({ status }: HealthBadgeProps): React.JSX.Element {
  const normalized = (status ?? "unknown").toLowerCase();
  const color = COLOR_MAP[normalized] ?? "default";
  return <Chip size="small" label={status ?? "unknown"} color={color} variant="filled" />;
}
